module.exports = __webpack_public_path__ + "img/medal_one_yellow.c789c328.png";